import React from "react";
import { Box, Chip, Typography } from "@material-ui/core";
import I18nText from "../../../elements/I18nText";
import { useTranslation } from "../../../i18n";

const ActiveFilterChips = ({ filters, onClearFilter, TYPE_BUTTONS }) => {
  const getActiveFilterChips = () => {
    const chips = [];
    const { t } = useTranslation();

    if (filters.searchTerm) {
      chips.push({
        key: "searchTerm",
        label: `${t(`topbar.search`)}: "${filters.searchTerm}"`,
        onDelete: () => onClearFilter("searchTerm")
      });
    }

    if (filters.typeFilter && filters.typeFilter !== "all") {
      const typeLabel =
        TYPE_BUTTONS.find(btn => btn.value === filters.typeFilter)?.label ||
        filters.typeFilter;
      chips.push({
        key: "typeFilter",
        label: `Type: ${typeLabel}`,
        onDelete: () => onClearFilter("typeFilter")
      });
    }

    if (filters.medium) {
      chips.push({
        key: "medium",
        label: `Medium: ${t(`sensors.contentTypes.${filters.medium}`)}`,
        onDelete: () => onClearFilter("medium")
      });
    }

    if (filters.status) {
      chips.push({
        key: "status",
        label: `Status: ${t(`devices.common.statuses.${filters.status}`)}`,
        onDelete: () => onClearFilter("status")
      });
    }

    return chips;
  };

  const activeChips = getActiveFilterChips();

  if (activeChips.length === 0) return null;

  return (
    <Box display="flex" flexWrap="wrap" gap={1} marginBottom={1}>
      <Typography
        variant="caption"
        style={{ alignSelf: "center", marginRight: 8 }}
      >
        <I18nText>devices.list.table.activeFilters</I18nText>
      </Typography>
      {activeChips.map(chip => (
        <Chip
          key={chip.key}
          label={chip.label}
          onDelete={chip.onDelete}
          size="small"
          color="primary"
          variant="outlined"
          style={{ marginRight: 4 }}
        />
      ))}
    </Box>
  );
};

export default ActiveFilterChips;
